import React from 'react'
import { useSelector } from 'react-redux';
import Cast from './Cast';

const CastDisplay = () => {
    const castDetails = useSelector((store)=> store.details?.CastDetails);
    
    const actors = castDetails?.cast?.filter((data)=> data?.known_for_department == 'Acting') 
  
    return (
    <div className='flex gap-3 justify-start align-top overflow-x-scroll'>      
        {actors?.map((data)=> <Cast image_url={data?.profile_path} original_name={data?.name} character={data?.character}/>)};   
    </div>
  )
}

export default CastDisplay